import { CALL_API2 } from "../Utils/const";
import { getAuthToken } from "../context/auth-context";

/* ===================== GET ALL ===================== */
export async function getAllChequeras() {
  const token = getAuthToken();
  const result = await fetch(`${CALL_API2}/chequera`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await result.json();
  if (!result.ok) throw new Error(data.message);

  return data.result;
}

/* ===================== GET BY ID ===================== */
export async function getChequeraById(idChequera) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API2}/chequera/${idChequera}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);

  return data.result;
}

/* ===================== GET ACTIVA ===================== */
export async function getActiveChequera() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API2}/chequera-activa`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);

  return data.result;
}

/* ===================== GET ACTIVA POR USUARIO ===================== */
export async function getActiveChequeraByUser() {
  const token = getAuthToken();
  const result = await fetch(`${CALL_API2}/chequera-usuario`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await result.json();
  if (!result.ok) throw new Error(data.message);

  return data.result;
}

/* ===================== SAVE (NEW / UPDATE) ===================== */
export async function saveChequera(chequeraObject) {
  const token = getAuthToken();
  const { isNew, idchequera } = chequeraObject;

  let urlSend = `${CALL_API2}/chequera`;
  let method = "POST";

  // 🔒 Normalizar estaActivo (SIEMPRE 0 o 1)
  const payload = {
    ...chequeraObject,
    estaActivo: chequeraObject.estaActivo ? 1 : 0,
  };

  delete payload.isNew;

  if (!isNew) {
    urlSend = `${urlSend}/${idchequera}`;
    method = "PUT";
    delete payload.idchequera;
  }

  const result = await fetch(urlSend, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await result.json();
  if (!result.ok) throw new Error(data.message);

  return data.isSaved;
}

/* ===================== DELETE ===================== */
export async function deleteChequera(idChequera) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API2}/chequera/${idChequera}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);

  return data.isDeleted;
}
